import { render } from "./FlatButton.vue?vue&type=template&id=1ca378b0&scoped=true"
import script from "./FlatButton.vue?vue&type=script&lang=js"
export * from "./FlatButton.vue?vue&type=script&lang=js"

import "./FlatButton.vue?vue&type=style&index=0&id=1ca378b0&scoped=true&lang=css"
import "./FlatButton.vue?vue&type=style&index=1&id=1ca378b0&lang=css"

import exportComponent from "E:\\Workspaces\\成品油\\成品油_基础版\\成品油溯源码（扫码）\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca378b0"]])

export default __exports__